import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import i18n from '@/i18n';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import configs from "@/configs";

Vue.use(Router);
const router = new Router({
    base: '/',
    mode: 'hash',
    linkActiveClass: 'active',
    routes: paths,
    mode: 'history'
});
const DEFAULT_TITLE = 'CHAUSALOG';
// router gards
router.beforeEach((to, from, next) => {
    NProgress.start();
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('jwt') == null) {
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        } else {
            let user = JSON.parse(localStorage.getItem('user'))
            if (user && user.roleid == configs.ROLE_TYPE.Customer && (to.name == 'Root' || to.name == 'Dashboard')) {
                next({
                    name: 'CustomerProductList'
                })
                return;
            }
            const role_type = _.find(configs.ROLES, {'value': user.roleid})
            if(role_type && (role_type.modules & to.meta.roleId)){
                next()
            }
            else {
                next({
                    path: '/'
                })
            }
        }
    } else if (to.matched.some(record => record.meta.public)) {
        if (localStorage.getItem('jwt') == null) {
            next()
        }
        else {
            next({
                path: '/'
            })
        }
    } else {
        next()
    }
    Vue.nextTick(() => {
        const title = to.meta.titleKey ? i18n.t(`${to.meta.titleKey}`) : to.meta.title;
        document.title = title ? title + (to.params.Pid ? ' #' + to.params.Pid : '') + ' | ' + DEFAULT_TITLE : DEFAULT_TITLE;
    });
});

router.afterEach((to, from) => {
    NProgress.done();
});

export default router;
